import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_sr_cyrl: IResource = {
    feedback_button_text: "Pošalji",
    feedback_cta_0_3: "Stvarno nam je žao, molimo Vas recite nam  šta da popravimo",
    feedback_cta_4_6: "To je stvarno šteta, možete nam reći šta da poboljšamo?",
    feedback_cta_7_8: "Šta da uradimo da učinimo Meet još boljim?",
    feedback_cta_9_10: "Fantastično! Šta Vam se najviše dopalo?",
    feedback_mail_subject: "Meet mišljenje ",
    feedback_text_legend: "Podjednako smo zahvalni i na pozitivnim i na negativnim mišljenjima",
    feedback_text_title: "Unesite svoje mišljenje ovde (opciono)",
    feedback_title_finished: "Vaš Meet je završen",
    feedback_title_ongoing: "Molimo Vas pomozite nam da poboljšamo Meet",
    feedback_title_question: "Koliko je verovatno da će te preporučiti Meet prijatelju ili kolegi?",
    feedback_value_best: "Vrlo verovatno",
    feedback_value_worst: "Skoro neverovatno",

    onboarding_button_jointext: "START",
    onboarding_description_four: "dugme.",
    onboarding_description_one: "S obzirom da koritite Meet po prvi put, možete podesiti kao Vas sagovornici vide.",
    onboarding_description_three: "START",
    onboarding_description_two: "Kad ste spremni, samo kliknite ",
    onboarding_label_color: "Boja",
    onboarding_label_consentAgree: "Slažem se sa Meet",
    onboarding_label_consentAnd: "i",
    onboarding_label_consentPrivacy: "Politikom Privatnosti",
    onboarding_label_consentTermsOfUse: "Uslovima korišćenja",
    onboarding_label_darkTheme: "Tamna tema",
    onboarding_label_firstName: "Vaše ime (neobavezno)",
    onboarding_label_green: "Zelena",
    onboarding_label_indigo: "Plava",
    onboarding_label_lastName: "Vaše preziome (neobavezno)",
    onboarding_label_lightTheme: "Svetla tema",
    onboarding_label_orange: "Narandžasta",
    onboarding_label_pink: "Lila",
    onboarding_label_purple: "Ljubičasta",
    onboarding_label_teal: "Tirkizna",
    onboarding_label_theme: "Tema",
    onboarding_label_yellow: "Žuta",
    onboarding_title: "Dobrodošli!",

    invite_legend_text: "Pošaljite link osobi sa kojom se sastajate",
    invite_link_copy: "Kopirajte link",
    invite_link_defaultCopied: "Link je kopiran",
    invite_link_email: "Email poziv",
    invite_link_label: "Vaš Meet link",
    invite_link_sms: "SMS poziv",
                        
    invite_mail_body: "Pozdrav, molim pridružite mi se na Meet-u!",
    invite_mail_signature: "S poštovanjem",
    invite_mail_subject: "Vaš link za Meet",
    invite_title_text: "POZOVITE NEKOG U MEET",

    citypicker_label: "Grad",
    citypicker_nomatch: "Nema sličnih gradova",

    userprofile_city_label: "Grad",
    userprofile_color_label: "Boja",
    userprofile_email_label: "E-mail adresa",
    userprofile_label_green: "Zelena",
    userprofile_label_indigo: "Plava",
    userprofile_label_orange: "Narandžasta",
    userprofile_label_pink: "Lila",
    userprofile_label_purple: "Ljubičasta",
    userprofile_label_teal: "Tirkizna",
    userprofile_label_yellow: "Žuta",
    userprofile_locale_label: "Jezik",
    userprofile_name_label: "Ime",
    userprofile_surname_label: "Prezime",
    userprofile_theme_label: "Tema",
    userprofile_themedark_label: "Tamna tema",
    userprofile_themelight_label: "Svetla tema",

    options_tab_profile: "Profil",

    consentdialog_button_cancel: "Otkaži",
    consentdialog_button_ok: "OK",

    layout_meet_end: "Kraj sastanka",
    layout_meet_leave: "Napustite sastanak",

    layout_sidebar_labelClose: "Zatvori bočni meni",
    layout_sidebar_labelOpen: "Otvori bočni meni",
    layout_sidebar_labelTitle: "Otvaranje bočnog menija",
    layout_title_text: "Meet | Sastanci bez muke",

    layout_toolbar_enter: "Prelazak u puni ekran",
    layout_toolbar_invite: "Dodajte sagovornika",
    layout_toolbar_invite_tooltip: "Pozovite novog sagovornika da se pridruži ovom sastanku",
    layout_toolbar_leave: "Izlazak iz punog ekrana",

    layout_dialog_descriptionEnd: "Ovo će okončati sastanak za sve učesnike",
    layout_dialog_titleEnd: "Da li ste sigurni da želite da okončate sastanak?",
    layout_dialog_titleLeave: "Da li želite da naustite ovaj sastanak?",

    layout_dialog_descriptionLeave: "Ovo NEĆE okončati sastanak za ostale učesnike",
    layout_sidebar_explorer: "Pomoć",
    layout_sidebar_feedback: "Vaše mišljenje",
    layout_sidebar_settings: "Podešavanja",

    layout_finish_endmeet: "Kraj sastanka",
    layout_finish_leavemeet: "Napustite sastanak",

    layout_cta_register: "Duži sastanak?",
    layout_cta_register_tooltip: "Registrujte se za sastanke duže od 20 min",

    layout_dialog_descriptionAbandon: "Izgleda da ste jš samo vi ostali na pozivu",
    layout_dialog_titleAbandon: "Da li želite da okončate ovaj sastanak?",

    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsche",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    meeting_finished_title: "ZAVRŠEN SASTANAK",
    meeting_finished_tooltip: "Ograničeni pristup",

    layout_reactivate_button: "Reaktivicaija Meet-а",
    layout_reactivate_tooltip: "Kliknite ovde da bi ste otvorili ovaj zavšeni Meet za ponovnu upotrebu",
    layout_dialog_titleReactivate: "Da li ste sigurni da želite da ponovo reaktivirate ovaj sastanak?",
    layout_dialog_descriptionReactivate: "Ovo će ponovo omogućiti korišćenje ovog Meet-a za razgovor i kolaboraciju",

    toast_reconnecting_title: "Problem sa signalizacijom poziva",
    toast_reconnecting_message: "Veza (stanje: {state}) je izgubljena zbog greške {error}. Ponovno povezivanje ...",
    toast_reconnected_title: "Signalizacija poziva",
    toast_reconnected_message: "Veza je uspostavljena. Stanje: {state}",
    toast_disconnected_title: "Greška u signalizaciji poziva",
    toast_disconnected_message: "Veza (stanje: {state}) je zatvorena zbog greške {error}." +
                                "Učitajte ponovo ovu stranicu da biste pokušali da obnovite vezu signalizacije poziva.",

    config_title_text: "Kreiraj new Meet",
    config_title_ctaOne: "Molimo Vas definišite atribute sastanaka koji želite da imate.",
    config_title_ctaTwo: "Svaki od atributa je opcion i možete ga preskočiti.",
    config_title_label: "Naziv",
    config_description_label: "Opis",
    config_duration_label: "Trajanje",
    config_tool_label: "Meet alati",
    config_tool_call: "Video poziv",
    config_tool_editor: "Editor koda",
    config_tool_whiteboard: "Tabla za crtanje",
    config_passcode_label: "Šifra za pristup (ako je ima)",

    search_placeholder_text: "Unesite kriterijum pretrage...",
    createMeeting_button_create: "Napravi Sastanak",

    projectboard_scheduleinfo_none: "Sastanak nema određen datum i može početi bilo kad",
    projectboard_scheduleinfo_anytime: "bilo kad",

    projectboard_join_anyone: "Bilo ko sa linkom može se priključiti pozivu",
    projectboard_role_guest: "Gost",
    projectboard_role_interviewee: "Kandidat",
    projectboard_role_interviewer: "Poslodavac",
    projectboard_role_organizer: "Organizator",

    projectboard_status_draft: "U izradi",
    projectboard_status_scheduling: "U zakazivanju",
    projectboard_status_schedulingFailed: "Zakazivanje neuspelo",
    projectboard_status_pending: "Spreman - na čekanju",
    projectboard_status_ready: "Spreman",
    projectboard_status_starting: "Počinje",
    projectboard_status_inprogress: "U toku",
    projectboard_status_onhold: "Na čekanju",
    projectboard_status_completed: "Završen",
    projectboard_status_canceled: "Otkazano",
    projectboard_status_archived: "Arhivirano",
    projectboard_status_feedbackWait: "Čekanje na povratnu informaciju",
    projectboard_status_feedbackDone: "Povratna informacija prikupljena",
    projectboard_status_feedbackFail: "Povratna informacija nije prikupljena",

    projectboard_status_stopped: "Prekinuto",

    minibar_dashboard_title: "Tabla",
    
    layout_sidebar_rateus: "Ocenite nas",

    invite_passcode_label: "Šifra",

    invite_text_copy: "Kopiraj poziv",
    
    invite_text_body: "Molim vas proidružite se sastanku na {url}",
    
    invite_passcode_body: "Pridružite se sastanku na {url} i koristite za prijavu lozinku {passcode}",

    invite_text_copied: "Tekst pozivnice za sastanak sa podacima za pristup je kopiran u ostavu (clipboard)",
            
    invite_pascode_add: "Dodaj šifru za prolaz URL adresi", 
    
    participant_join_message:  "{participant} se pridružio sastanku.",
    participant_left_message:  "{participant} je napustio sastanak.",

    minibar_dashboard_tooltip: "Upravljanje vašim Meet-ovima",
    
    layout_sidebar_snapshot: "Snimci",

    snapshots_none_text: "Napravite jedan ili više snimaka koda i table za crtanje i pregledajte ih nakon sastanka.",
    snapshots_cta_text: "Napravite snimak (F9)",
    snapshot_toast_text: "Snimak sačuvan",
    snapshot_sentiment_positive: "Pozitivan snimak",
    snapshot_sentiment_negative: "Negativan snimak",
    snapshot_sentiment_note: "Napomena",

    snapshot_personal_value: "Lični snimak",
    snapshot_personal_title: "Vidljivo samo tebi",
    snapshot_team_value: "Snimak tima",
    snapshot_team_title: "Vidljivo samo vašem timu.",
    snapshot_public_title: "Vidljivo svim učesnicima",
    snapshot_public_value: "Javni snimak",

    snapshots_live_text: "Vrati se u intervjuu uživo",
    
    snapshot_action_delete: "Izbriši",
    snapshot_action_load: "Učitaj snimak",
    
    snapshot_delete_dialog_title: "Izbriši snimak?",
    snapshot_delete_dialog_description: "Molimo vas da potvrdite da želite da izbrišete ovaj snimak",
    snapshots_final_back: "Nazad na konačno stanje Meet-a",

};

export default translation_sr_cyrl;
